import { inject, Injectable } from '@angular/core';
import {
  Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';
import { catchError, Observable } from 'rxjs';
import { TournamentService } from '@doc/api/server-bo';

@Injectable({
  providedIn: 'root'
})
export class TournamentResolver implements Resolve<any> {
 
  private tournamentService = inject(TournamentService);

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    return this.tournamentService.getAllTournaments({}).pipe(
      catchError(error => {
        return [];
      })
    )
  }
}
